var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgBgFeat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 419,
    viewBox: "0 0 466 419",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.957-144C3.991-53.497-38.658 160.798 94.477 293.958 227.613 427.117 408.966 424.12 483 405.978",
    stroke: "#20FFC3",
    strokeWidth: 8,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5,
    strokeDasharray: "0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgFeat1);
export default __webpack_public_path__ + "static/media/imgBgFeat1.9b60f472f2aac573e1c819e1f2b3fee6.svg";
export { ForwardRef as ReactComponent };